export default "__VITE_ASSET__B$daTLN7__"